import { tJosa } from '@mathflat/shared/i18n/tJosa'
import { canBeChoseong, getChoseong } from 'es-hangul'

const stringUtils = {
  matchesText(target: string, search: string): boolean {
    const isChoseong = [...search].every((char) => canBeChoseong(char))
    if (isChoseong) return getChoseong(target).includes(search)
    return target.toLowerCase().includes(search.toLowerCase())
  },
  replaceAllDashes(phone: string) {
    return phone.replace(/-/g, '')
  },
  toDashedPhone(phone: string) {
    const phoneNumber = phone.replace(/-/g, '')
    const regionNumber = phoneNumber.slice(0, 2)

    if (phoneNumber.length === 11) return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
    if (phoneNumber.length === 10) {
      if (regionNumber === '02') return phoneNumber.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3')
      return phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
    }
    if (phone.length === 9) {
      if (regionNumber === '02') return phone.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3')
      return phoneNumber.replace(/(\d{3})(\d{3})(\d{3})/, '$1-$2-$3')
    }
    if (phoneNumber.length === 12 && /^050\d/.test(phoneNumber)) {
      return phoneNumber.replace(/(\d{4})(\d{4})(\d{4})/, '$1-$2-$3')
    }

    return phone
  },

  /** 예: maskTail('8881234') → '888****' */
  maskTail(value: string, visibleCount = 3) {
    if (value.length <= visibleCount) return value
    return value.slice(0, visibleCount) + '*'.repeat(value.length - visibleCount)
  },

  toNumber(text: string, opts: { fallbackValue: number } = { fallbackValue: 0 }) {
    if (!text) return opts.fallbackValue

    const result = parseInt(text.replace(/[^0-9]/g, ''))
    if (!Number.isInteger(result)) {
      return opts.fallbackValue
    }
    return result
  },

  // 암호화 복호화 함수 생성
  // createTransducer() {
  //   return {
  //     encoder: (str: string) => str.replace(/\//g, '__CODE__'),
  //     decoder: (str: string) => str.replace(/__CODE__/g, '/'),
  //   }
  // },

  makeAssignCountText(name?: string, listLength?: number, defaultText = `${tJosa('출제')}하기`) {
    if (listLength === undefined || listLength === 0) return defaultText
    if (listLength === 1) return name ?? '1명'
    return name ? `${name} 외 ${listLength - 1}명` : `${listLength}명`
  },
  addZeroWidthSpace(text: string) {
    // 사파이에서 work-break: keep-all 적용 시 (는 크롬과 다르게 판단해서
    // 줄바꿈이 안되어서 width가 없는 빈 공백문자(\u200B or &#8203;)로 치환해서 리턴
    return text.replace(/\(/g, '\u200B (')
  },
  // "중1-1(22개정)" → "중1-1<br/>(22개정)" 으로 변환해 줄바꿈 처리
  insert개정줄바꿈(text: string) {
    if (!text.includes('(22개정)')) return <>{text}</>
    const [before] = text.split('(22개정)')
    return (
      <>
        {before}
        <br />
        (22개정)
      </>
    )
  },
  모의고사쌍둥이텍스트줄바꿈(text: string) {
    if (text !== '모의고사쌍둥이') return text
    return (
      <>
        모의고사
        <br />
        쌍둥이
      </>
    )
  },
  generateNumberScope(input: string, exclusions: number[]) {
    const result: string[] = []
    const ranges: string[] = input.split(',') // "1-3,5-7,9-10"
    exclusions.sort((a, b) => a - b)

    const flatOriginArray = ranges.flatMap((range) => {
      const [start, end] = range.split('-').map((strNum) => parseInt(strNum))
      return Array.from({ length: end - start + 1 }, (_, i) => start + i)
    })

    const excludedArray = flatOriginArray.filter((num) => !exclusions.includes(num))

    let start = excludedArray[0]
    for (let i = 0; i < excludedArray.length; i++) {
      const current = excludedArray[i]
      const next = excludedArray[i + 1]

      if (current + 1 === next) {
        continue
      }

      if (start === current) {
        result.push(`${current}`)
      } else {
        result.push(`${start}-${current}`)
      }

      start = excludedArray[i + 1]
    }

    return result.join(',')
  },

  applyEllipsis: (originalText: string, maxLength: number) => {
    if (originalText.length > maxLength) {
      const truncatedText = originalText.substring(0, maxLength) + '...'
      return truncatedText
    }
    return originalText
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mergePropertiesWithChar: (p1: any, p2: any, char = '_') => {
    const _p1 = p1.toString().trim().replace(/ /g, '')
    const _p2 = p2.toString().trim().replace(/ /g, '')

    return _p1 + char + _p2
  },

  formatBirthDateWithDashed(birthDate: string) {
    const formatDate = (dateString: string) => {
      const yearPrefix = parseInt(dateString.slice(0, 2), 10) >= 50 ? '19' : '20'
      return `${yearPrefix}${dateString.slice(0, 2)}-${dateString.slice(2, 4)}-${dateString.slice(4, 6)}`
    }
    return formatDate(birthDate)
  },
}
export default stringUtils
